import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import startupIllustration from '../../assets/img/illustrations/startup.svg';

const Error404 = ({ eyebrow, title, description, codeLabel, homeLabel }) => {
  return (
    <div className="psi-error-page">
      <div className="psi-error-page__orb psi-error-page__orb--left" />
      <div className="psi-error-page__orb psi-error-page__orb--right" />

      <div className="psi-error-card">
        <div className="psi-error-card__visual">
          <div className="psi-error-card__image-shell">
            <img src={startupIllustration} alt="404 illustration" className="psi-error-card__image" />
          </div>
        </div>

        <div className="psi-error-card__content">
          <span className="psi-error-card__eyebrow">{eyebrow}</span>
          <div className="psi-error-card__code">{codeLabel}</div>
          <h2>{title}</h2>
          <p>{description}</p>
          <div className="psi-error-card__actions">
            <Link className="btn btn-primary psi-error-card__action" to="/">
              <FontAwesomeIcon icon="home" className="mr-2" />
              {homeLabel}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

Error404.propTypes = {
  eyebrow: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  codeLabel: PropTypes.string,
  homeLabel: PropTypes.string
};

Error404.defaultProps = {
  eyebrow: 'Sahifa topilmadi',
  title: 'Menyudagi ushbu manzil hozircha mavjud emas yoki ko‘chirilgan.',
  description:
    'Havola eskirgan bo‘lishi, sahifa hali tayyor bo‘lmasligi yoki manzil noto‘g‘ri ochilgan bo‘lishi mumkin. Ishchi bo‘limga qayting yoki oldingi oynaga qayta urinib ko‘ring.',
  codeLabel: '404',
  homeLabel: 'Dashboardga qaytish'
};

export default Error404;
